import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import InsightsPage from "./pages/InsightsPage";
import NotFoundPage from "./pages/NotFoundPage";
import { Footer, Header } from "./components";
import AboutUsPage from "./pages/AboutUsPage";
import PersonDetailPage from "./pages/PersonDetailPage";
import ScrollToTop from "./components/common/ScrollToTop";
import ScrollToTopButton from "./components/common/ScrollToTopButton";
import BlogContentsPage from "./pages/BlogContentsPage";
import NewsContentsPage from "./pages/NewsContentsPage";
import EventsContentsPage from "./pages/EventsContentsPage";
import AIAgentPage from "./pages/AIAgentPage";

// Component to conditionally render header
function ConditionalHeader() {
  const location = useLocation();
  const isPersonDetailPage = location.pathname.includes('/person/');
  const isBlogPage = location.pathname.includes('/blog/');
  const isNewsPage = location.pathname.includes('/news/');
  const isEventsPage = location.pathname.includes('/events/');

  if (isPersonDetailPage || isBlogPage || isNewsPage || isEventsPage) {
    return <Header showOnlyLogo={true} />;
  }

  return <Header />;
}

export default function App() {
  return (
    <Router>
      <div className="bg-[#050011] relative min-h-screen text-white overflow-x-hidden">
        {/* Background Image - Placeholder for now */}
        <div
          className="fixed inset-0 opacity-[0.24] bg-no-repeat bg-cover pointer-events-none"
          style={{
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
          }}
        />

        {/* Main Content */}
        <div className="relative z-10 max-w-[1440px] mx-auto">
          <ScrollToTop />
          <ConditionalHeader />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/insights" element={<InsightsPage />}>
              <Route path="news/:id" element={<NewsContentsPage />} />
              <Route path="blog/:id" element={<BlogContentsPage />} />
              <Route path="events/:id" element={<EventsContentsPage />} />
            </Route>
            <Route path="/ai-agents" element={<AIAgentPage />} />
            <Route path="/about-us" element={<AboutUsPage />}>
              <Route path="person/:id" element={<PersonDetailPage />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>

          <Footer />
        </div>
        
        {/* Scroll to Top Button */}
        <ScrollToTopButton />
      </div>
    </Router>
  );
}
